import { useTranslation } from "@redotech/redo-i18n";
import type { EvidenceState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { StepImageUpload } from "./step-image-upload";

export const EvidenceDetails = memo(function EvidenceDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<EvidenceState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Prompt")}
        </Text>
        <RedoTextareaInputField
          placeholder={t("Instructions for what evidence to capture")}
          setValue={(prompt) => setState((state) => ({ ...state, prompt }))}
          value={state.prompt}
        />
      </Flex>
      <StepImageUpload
        imageUrl={state.imageUrl}
        setImageUrl={(imageUrl) =>
          setState((state) => ({ ...state, imageUrl }))
        }
      />
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Notes label (optional)")}
        </Text>
        <RedoTextInput
          placeholder={t("e.g. Notes about the damage")}
          setValue={(notesLabel) =>
            setState((state) => ({ ...state, notesLabel }))
          }
          value={state.notesLabel ?? ""}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Notes placeholder (optional)")}
        </Text>
        <RedoTextInput
          placeholder={t("e.g. Describe what you see…")}
          setValue={(notesPlaceholder) =>
            setState((state) => ({ ...state, notesPlaceholder }))
          }
          value={state.notesPlaceholder ?? ""}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Next step")}
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
      </Flex>
    </Flex>
  );
});
